export default "__VITE_ASSET__DlBL7pCZ__"